/**
 * Formats the Destiny map legend count badge (`inView / total`).
 *
 * While the in-viewport count is loading, keeps the known total and leaves the
 * left side empty so {@link LegendItem} can render its spinner (`⟳ / 520`).
 */
export function formatLegendCountLabel(args: {
	count?: number;
	totalCount?: number;
	countLoading?: boolean;
	/** When false, only the total is shown (layer hidden). @default true */
	visible?: boolean;
}): string | null {
	const { count, totalCount, countLoading = false, visible = true } = args;

	if (!visible) {
		return totalCount !== undefined ? `${totalCount}` : null;
	}

	if (countLoading) {
		return totalCount !== undefined ? ` / ${totalCount}` : "";
	}

	if (count !== undefined && totalCount !== undefined) {
		return `${count} / ${totalCount}`;
	}

	if (totalCount !== undefined) {
		return `${totalCount}`;
	}

	return null;
}
